import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Directive({
    selector: '[fiPatternAsync]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: FiPatternAsyncValidatorDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiPatternAsyncValidatorDirective implements AsyncValidator {
    @Input() fiPatternAsync: string;
    readonly validationDelayMS: number = 300;

    validate(control: AbstractControl): Observable<ValidationErrors> {
        const promise = control.valueChanges.pipe(
            debounceTime(this.validationDelayMS),
            distinctUntilChanged(),
            map((value: string): ValidationErrors => {
                if (!value) return null;

                const isControlValid: boolean = new RegExp(this.fiPatternAsync).test(value);
                return isControlValid ? null : { fiPatternAsync: true };
            }),
            first(),
        );
        return promise;
    }
}
